import type { FaireProductEntity } from "../../entity_types/product";

export const p_z69ucn37ph: FaireProductEntity = {
  token: "p_z69ucn37ph",
  type: "product",
  name: "Miss Blush - Blush Linen Pillow Cover",
  brandToken: "b_4le94y2c",
  brandName: "Willa Skye Home",
  imageUrl: "https://cdn.faire.com/fastly/77ca520596e0165e5befbdd1a9a8d21771f73b40145625632297eb3aa416737a.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.96,
  description: "100% Linen Pillow Cover in Blush Linen. The perfect shade of blush decorative pillow!\n\nZipper Enclosure\n\nPillow insert not included\n",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:10:59.612Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
